import { Alert, Button } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import ErrorsString from "../ErrorsString";
import { useParams } from "react-router-dom";
import { GetDetailsModel } from "../models/GetDetailsModel";
import { DetailsResponse } from "../models/ResponseModels/DetailsResponse";
import Spinner from "../components/Spinner";
import config from "../config";
import DropDownMenu from "../components/DropDownMenu";
import ImageDetailsModal from "../components/ImageDetailsModal";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import ImagesTypeAccordionBox from "../components/ImagesTypeAccordionBox";
import ImagesEpisodeAccordionBox from "../components/ImagesEpisodeAccordionBox";
import DetailField from "../components/DetailField";
import { workOrderDetailsSections } from "../configurations/workOrderDetailsSections";

export default function WorkOrderDetailsPage() {
  const { uuid } = useParams();
  const [spinnerVisibility, setSpinnerVisibility] = useState(false);
  let [alertMessage, setAlertMessage] = useState<string>("");
  let [showAlert, setShowAlert] = useState<boolean>(false);
  let [isFollowed, setIsFollowed] = useState<boolean>(false);
  let [openModal, setOpenModal] = useState<boolean>(false);
  const [details, setDetails] = useState<DetailsResponse | null>(null);
  // const [url, setUrl] = useState<string | null>(null);
  //const location = useLocation();
  //const parameters = JSON.parse(location.state) || null;
  const [selectedUuid, setSelectedUuid] = useState<string | null>(null);
  const [expandedList, setExpandedList] = useState<string[] | null>([]); // Lista di accordion aperti
  const [isExpandAll, setIsExpandAll] = useState(false); // Stato per il pulsante Expand/Collapse All

  const getDetails = useCallback(() => {
    window.scrollTo(0, 0);
    setSpinnerVisibility(true);

    console.log("Starting API call GetDetailsModel...");
    (async () => {
      const response = await GetDetailsModel(uuid);
      console.log("GetDetailsModel response: " + JSON.stringify(response));

      const responseData = response?.data;
      const statusCode = response?.status;

      if (responseData === undefined) {
        setError(ErrorsString.errorMessageGeneric);

        return;
      }

      if (statusCode !== 200) {
        const errorMsg = responseData.message
          ? ErrorsString.errorMessageGeneric + " : " + responseData.message
          : ErrorsString.errorMessageGeneric;

        setError(errorMsg);

        return;
      }

      //STATUS 200
      if (responseData.code === "1") {
        setDetails(responseData);
        setIsFollowed(responseData.isFollowed);
      } else if (responseData.code === "0") {
        setError(ErrorsString.noPermission);
        return;
      }
      setSpinnerVisibility(false);

      return;
    })();
  }, [uuid]);

  function setError(message: string) {
    setAlertMessage(message);
    setShowAlert(true);
    setSpinnerVisibility(false);
  }

  useEffect(() => {
    /*if (parameters !== null && parameters.previewImageUrl !== null) {
      setUrl(
        config.cloudfrontImgUrl +
          "" +
          parameters.previewImageUrl +
          config.showImagesQuery,
      );
    } else if (parameters !== null && parameters.previewImageUrl === null) {
      setUrl(config.placeholderImageUrl);
    }*/
    getDetails();
  }, [getDetails]);

  useEffect(() => {
    if (!openModal) {
      const scrollY = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }
  }, [openModal]);

  function handleExpandAllToggle() {
    // Funzione per espandere o collassare tutti gli accordion
    //console.log(expandedList);
    if (isExpandAll) {
      setExpandedList([]); // Svuota la lista di accordion aperti
    } else {
      const indexList = [
        // Se imageLinkedToWo esiste, aggiungi le sue chiavi
        ...(details.imageLinkedToWo
          ? Object.keys(details.imageLinkedToWo).map(
              (label, index) => "accordionBox_type_" + index,
            )
          : []),

        // Itera su episodeLinkedImages, se esiste
        ...(details.episodeLinkedImages
          ? Object.keys(details.episodeLinkedImages).flatMap(
              (label, episodeIndex) => {
                const result = [];

                // Aggiungi la voce principale per l'episodio
                result.push("accordionBox_episode_" + episodeIndex);

                // Itera sulle sotto-chiavi dell'episodio
                const episodeDetails = details.episodeLinkedImages[label];

                var episodeIndexImage = 0;
                Object.keys(episodeDetails).forEach((key) => {
                  const array = episodeDetails[key];
                  // Se il valore è un array non vuoto, aggiungi "accordionBox_type_" + index
                  if (Array.isArray(array) && array.length > 0) {
                    array.forEach((episodeImage, episodeImageIndex) => {
                      result.push(
                        "accordionBox_type_" +
                          episodeIndex +
                          "_" +
                          episodeIndexImage,
                      );

                      episodeIndexImage = episodeIndexImage + 1;
                    });
                  }
                });

                return result; // Restituisci l'array dei risultati
              },
            )
          : []),
      ];
      setExpandedList(indexList); // Aggiunge tutti gli accordion nella lista
    }
    setIsExpandAll(!isExpandAll); // Cambia il testo del pulsante
  }

  return (
    <>
      <Spinner visibility={spinnerVisibility} />
      <div className=" mt-5">
        {details ? (
          <div id="content-body" className="">
            <div id="box-info" className="flex flex-row gap-4 p-4 h-1/2 ">
              <div id="content-preview-image" className="p-4 w-1/2">
                <img
                  src={
                    details.previewUrl != null
                      ? config.cloudfrontImgUrl +
                        details.previewUrl +
                        config.showImagesQuery
                      : config.placeholderImageUrl
                  }
                  alt=""
                  className="w-full h-full"
                />
              </div>
              <div id="content-details" className=" p-4 w-full">
                <div className="float-right">
                  <DropDownMenu
                    uuid={uuid}
                    isFollowed={isFollowed}
                  ></DropDownMenu>
                </div>
                <div id="details" className="mt-6 ">
                  {workOrderDetailsSections.map((field) => (
                    <DetailField
                      key={field.id}
                      field={field}
                      value={details[field.key]}
                    />
                  ))}
                </div>
              </div>
            </div>

            <div id="content-images" className="p-7">
              {(details.imageLinkedToWo &&
                Object.keys(details.imageLinkedToWo).length > 0) ||
              (details.episodeLinkedImages &&
                Object.keys(details.episodeLinkedImages).length > 0) ? (
                <>
                  <div className="mb-5 h-8">
                    <Button
                      onClick={handleExpandAllToggle}
                      variant="contained"
                      className="float-right"
                    >
                      {isExpandAll ? <UnfoldLessIcon /> : <UnfoldMoreIcon />}
                      {isExpandAll ? "Collapse All" : "Expand All"}
                    </Button>
                  </div>

                  <div id="content-accordion" className="mt-5 ">
                    {details.imageLinkedToWo &&
                      Object.keys(details.imageLinkedToWo).length > 0 &&
                      Object.keys(details.imageLinkedToWo).map(
                        (label, index) => (
                          <ImagesTypeAccordionBox
                            key={`type_${label}_${index}`}
                            index={index.toString()}
                            label={label}
                            imagesArray={details.imageLinkedToWo[label]}
                            openModal={openModal}
                            setOpenModal={setOpenModal}
                            uuid={uuid}
                            setSelectedUuid={setSelectedUuid}
                            expandedList={expandedList}
                            setExpandedList={setExpandedList}
                            workOrderTitle={details.title}
                          ></ImagesTypeAccordionBox>
                        ),
                      )}

                    {details.episodeLinkedImages &&
                      Object.keys(details.episodeLinkedImages).length > 0 &&
                      Object.keys(details.episodeLinkedImages).map(
                        (label, index) => (
                          <ImagesEpisodeAccordionBox
                            key={`episode_${label}_${index}`}
                            index={index}
                            episodeName={label}
                            typesArray={details.episodeLinkedImages[label]}
                            openModal={openModal}
                            setOpenModal={setOpenModal}
                            uuid={uuid}
                            setSelectedUuid={setSelectedUuid}
                            expandedList={expandedList}
                            setExpandedList={setExpandedList}
                          ></ImagesEpisodeAccordionBox>
                        ),
                      )}
                  </div>
                  <ImageDetailsModal
                    openModal={openModal}
                    setOpenModal={setOpenModal}
                    uuid={selectedUuid}
                    setSelectedUuid={setSelectedUuid}
                  ></ImageDetailsModal>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        ) : (
          <Alert
            id="details-alert-message"
            severity="error"
            style={{
              display: showAlert ? "flex" : "none",
            }}
          >
            {alertMessage}
          </Alert>
        )}
      </div>
    </>
  );
}
